import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Observable } from 'rxjs';
import { OperationsUrlSettingsSearch } from 'src/app/search/configuration/operations-url-settings-search';
import { environment } from '../../../../environments/environment';
import { ServicePathsSettings } from "../../configuration/service-paths-settings";
import { UrlSettingsCore } from "../../configuration/url-settings-core";
import { HelpersService } from '../../services/helpers.service';
import { UserManager } from "../../services/user-manager";
import { ViewManagerService } from "../../services/view-manager-service";
import { ResponsiveService } from '../../services/responsive.service';
import { Breakpoints } from '@angular/cdk/layout';
import { AppData } from 'src/app/data-store';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { pdaConfiguration } from 'src/app/pda/utils/pda-configuration';
import { PdaAccessToken, PdaAuthService } from 'src/app/pda/utils/Service/pda-auth.service';
import { ConfigurationFeature } from 'src/app/common/configuration/models/configuration';
import { OauthService } from 'src/app/oauth.service';
import { UserProfileFlagStore } from 'src/app/utility/store/user-profile-flag';
import { SsoStrategyService } from 'src/app/sso-strategy.service';
import { PdaConfigurationService } from 'src/app/pda/utils/Service/pda-config.service';

declare var logoutApp;
declare var openModal: any;
@Component({
    selector: '[user]',
    templateUrl: 'user.component.html',
    styleUrls: ['user.component.css']
})

export class UserComponent implements OnInit {

  userdata: any;
  viewButtonChangePwd: boolean = false;
  viewButtonProfiloUtente: 'true' | 'false' = null;
  http: HttpClient;
  pathlogout: string;
  host: string = window.location.hostname;
	porta: string = window.location.port;
  logoutAddress:string;
  logoutRedirect:string;
  able: boolean = false;
  selectedTenant: any = null;
  loginTenantLabel: any;
  userTenants: any;
  labelTenant: any;
  loginTenant: any;
  loginSso: boolean;
  isHandsetSizeScreen: boolean;
  @Input() hideInfo = false;
  constructor(
    private pdaAuthService: PdaAuthService,
    private pdaConfigService: PdaConfigurationService,
    private responsive: ResponsiveService,
    private helpers: HelpersService,  
    private userManager: UserManager, 
    private router: Router, 
    http:HttpClient, 
    private viewManager: ViewManagerService,
    private oAuthService: OauthService,
    private ssoStrategy: SsoStrategyService,
  ) {
    this.http = http;
  }

  get dynamicInjection() {
    return this.viewManager.dynamicInjectComponent("USER");
  }


  ngOnInit() {
    // this.userdata = this.helpers.getLoggedUserData().subscribe(response => this.userdata = response);
    this.responsive.checkScreenSizeDynamic([Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait]).subscribe(
      state => this.isHandsetSizeScreen = state.matches
    )
    this.loginSso = environment.sso;

    if(!AppData.getInstance().loggedUser) {
      this.getUserData();
    } else {
      this.userdata = AppData.getInstance().loggedUser;
      this.setUserData();
    }
    // this.loginTenant = this.userdata.loginTenant.nomeGruppo;
    // this.loginTenantLabel = this.userdata.loginTenant.nomeGruppo;
    // this.userTenants = this.userdata.userTenants;
    if (this.userdata.tenantChoiceToDo == true) {
      openModal('tenantLogged');
    }
    let lengthTenants = this.userdata?.userTenants?.length;
    if (lengthTenants <= 1) {
      this.able = true;
    }
    // this.pdaConfigService.getConfigurationProperties().subscribe(() => console.log("pda config initiated"));
  }

  private getUserData() {
    this.userdata = this.helpers.getLoggedUserData().subscribe(response => {
      AppData.getInstance().loggedUser = response;
      this.userdata = response;
      this.setUserData();
    });
  }

  setUserData() {
    this.userManager.setLogout(false);
    this.loginTenant = this.userdata.loginTenant.nomeGruppo;
    this.loginTenantLabel = this.userdata.loginTenant.nomeGruppo;
    this.userTenants = this.userdata.userTenants;
    if (this.userdata.tenantChoiceToDo == true) {
      openModal('tenantLogged');
    }
    let lengthTenants = this.userdata?.userTenants?.length;
    if (lengthTenants <= 1) {
      this.able = true;
    }
    this.getProfiloUtente();
  }

  getProfiloUtente() {
    if(!UserProfileFlagStore.getInstance().canActivateUserProfile) {
      this.userManager.getFlagProfiloUtente().subscribe({
        next: response => {
          UserProfileFlagStore.getInstance().canActivateUserProfile = response.valore;
          this.viewButtonProfiloUtente = response.valore;
        },
        error: () => {
          this.viewButtonProfiloUtente = null;
          UserProfileFlagStore.getInstance().canActivateUserProfile = null;
        }
      });
    } else {
      this.viewButtonProfiloUtente = UserProfileFlagStore.getInstance().canActivateUserProfile;
    }

    if(!UserProfileFlagStore.getInstance().MAX_PREVIEW_FILE_SIZE) {
      this.userManager.getFlagMaxSizeFile().subscribe({
        next: (response: any) => {
          UserProfileFlagStore.getInstance().MAX_PREVIEW_FILE_SIZE = JSON.parse(response.valore);
        },
        error: () => {
          UserProfileFlagStore.getInstance().MAX_PREVIEW_FILE_SIZE = null;
        }
      })
    }
  }

  selectChangeHandler () {
    console.log(this.selectedTenant)
    if(!AppData.getInstance().loggedUser) {
      this.helpers.getLoggedUserData().subscribe(response => {
        this.userdata = response;
        for (let i = 0; i <= this.userdata.userTenants.length - 1; i++) {
          if (this.userdata.userTenants[i].id === this.selectedTenant) {
            this.labelTenant = this.userdata.userTenants[i].nomeGruppo;
          }
        }});
      openModal('tenantChoice');
    } else {
      this.userdata = AppData.getInstance().loggedUser;
      for (let i = 0; i <= this.userdata.userTenants.length - 1; i++) {
        if (this.userdata.userTenants[i].id === this.selectedTenant) {
          this.labelTenant = this.userdata.userTenants[i].nomeGruppo;
        }
      }
    }
  }


  changeTenant() {
    this.helpers.changeTenant(this.selectedTenant).subscribe(response => {
      console.log(response);
      window.location.reload();
    });
  }

  cancel() {
    this.selectedTenant = null;
    console.log(this.selectedTenant);
  }

  navigateToUserProfile(){
    this.responsive.closeSidebar();
    this.router.navigate([UrlSettingsCore.URL_PROFILO_UTENTE]);
  }

  async logout() {
    AppData.getInstance().loggedUser = null;
    this.userManager.setLogout(true);
    this.userManager.setLogout(true);
    this.userManager.sendUserLogged(false);
    this.userManager.clearUser();
    this.userManager.clearUserLogged();
    this.viewManager.resetCacheDescrittori();
    if(this.ssoStrategy.getAuthMode() === "ldap") {
      this.helpers.logoutReport().subscribe(() => console.log('ok'));
      this.helpers.logout().subscribe(response => {
        if (this.loginSso) {
          window.location.href = ServicePathsSettings.DOMINIO + '/' + UrlSettingsCore.URL_SSO;
        } else {
          this.router.navigate([UrlSettingsCore.URL_LOGIN]);
        }
      });
    } else {
      this.logoutOAuth();
    }
    this.clearPda();
  }

  private logoutOAuth() {
    if(this.oAuthService.isTokenIdValid()) {
      this.oAuthService.invalidateTokenSession();
    } else {
      // nel caso in cui id token hint fosse nullo o invalido bypasso la logout
      // pulisco la sessione e accedo nuovamente
      this.oAuthService.clearOAuthData();
      this.oAuthService.redirectToKeycloak(AppData.getInstance().idpHint);
    }
  }

  async clearPda() {
    this.pdaAuthService.removePdaInfos();
    this.pdaAuthService.removePdaToken();
    pdaConfiguration.forEach(x => {
      if (x.context !== "USER" && x.context !== NomiDescrittoriSezione.DESCRITTORE_CANCELLERIA_TELEMATICA) x.enabled = false;
    });
    this.pdaAuthService.setIsLogged(false);

  }

}
